import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorSettingsService {

  url = environment.serverAPI8;
  constructor(
    private http: HttpClient
  ) { }
  // getAllUpdatedSettingData(vendorid:any): Observable<Object> {
  //   return this.http.get(`${this.url}/vendor/${vendorid}/whatsapp_cloud_api_setup/get-update-data`);
  // }
  getAllUpdatedSettingData(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/whatsapp_cloud_api_setup/get-update-data`);
  }
  getAllVendorHealthData(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/health-data`);
  }
  getAllVendorRefreshedHealthData(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/refresh-health-data`);
  }
  saveVendorSettingsData(payload: any): Observable<Object> {
    const url = `${this.url}/api/vendor/update`;
    return this.http.post<Object>(url, payload);
  }
  saveWebHookSettingsData(payload: any): Observable<Object> {
    const url = `${this.url}/api/vendor/update`;
    return this.http.post<Object>(url, payload);
  }
  syncPhoneNumbers(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/sync-phone-numbers`);
  }
  disconnectWhatsapp(): Observable<Object> {
    return this.http.post(`${this.url}/api/vendor/disconnect`, {});
  }

  qrCode(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/qrCode`);
  }

  defaultBot(): Observable<any> {
    return this.http.get(`${this.url}/api/vendor/defaultBot`, { responseType: 'text' as 'json' });
  }

  openAI(): Observable<any> {
    return this.http.get(`${this.url}/api/vendor/openAI`, { responseType: 'text'});
  }

  generateToken(): Observable<string> {
    return this.http.get(`${this.url}/api/vendor/generateToken`, { responseType: 'text' });
  }


  getApiDetails(): Observable<Object> {
    return this.http.get(`${this.url}/api/vendor/getApiInfo`);
  }




}
